import createAppInjectors from 'angieslist-app-platform/lib/createAppInjectors';
import { httpClient, urlCatalog as urls } from 'angieslist-app-platform';
import { get } from 'lodash';
import appReducer from './app/browser/redux/appReducer';

export default createAppInjectors({
  beforeConfigureStore: (options) => {
    const storeOptions = {
      reducers: {
        ...(options || {}).reducers,
        forwardedHeaders: (state = {}) => state,
        googleVerification: (state = {}) => state,
        visitorAppReducer: appReducer,
      },
    };
    return storeOptions;
  },
  afterConfigureStore: (store) => {
    if (process.env.NODE_ENV !== 'development') {
      urls.initialize({
        baseUrls: {
          member: get(store.getState(), 'config.memberUrl'),
          office: get(store.getState(), 'config.officeUrl'),
          visitor: get(store.getState(), 'config.visitorUrl'),
          drupal: get(store.getState(), 'config.drupalUrl'),
          serviceRequest: get(store.getState(), 'config.serviceRequestUrl'),
        },
      });
      httpClient.initialize({ baseUrl: get(store.getState(), 'config.visitorUrl') });
    }
  },
});



// WEBPACK FOOTER //
// ./src/appInjectors.js